import { IFile } from '@/types/fileTypes';
import helpers from '@/helpers/index';
import { ThumbnailDimensions, ThumbnailSizes, FileDimension } from '@/constants/file';

const imagesFilesExtensions = ['.jpg', '.png', '.gif', '.jpeg'];
const threeDFilesExtensions = ['.stl', '.obj'];
const videoFilesExtensions = ['.avi', '.mp4', '.mpeg', '.wmv', '.flv', '.mov', '.qt'];
export default {
  imagesFilesExtensions: imagesFilesExtensions,
  threeDFilesExtensions: threeDFilesExtensions,
  videoFilesExtensions: videoFilesExtensions,

  is3DFile(extension: string): boolean {
    extension = extension?.toLowerCase();
    return (
      threeDFilesExtensions.includes(extension) || threeDFilesExtensions.includes('.' + extension)
    );
  },
  isVideoFile(extension: string): boolean {
    extension = extension?.toLowerCase();
    return (
      videoFilesExtensions.includes(extension) || videoFilesExtensions.includes('.' + extension)
    );
  },

  isImageFile(extension: string): boolean {
    extension = extension?.toLowerCase();
    return (
      imagesFilesExtensions.includes(extension) || imagesFilesExtensions.includes('.' + extension)
    );
  },

  fileSizeFormat(bytesNumber: number | undefined): string {
    const sizes = ['Bytes', 'kB', 'MB', 'GB', 'TB'];
    if (bytesNumber == undefined || bytesNumber == 0) return '0 Byte';
    const i = parseInt(String(Math.floor(Math.log(bytesNumber) / Math.log(1024))));
    return Math.round(bytesNumber / Math.pow(1024, i)) + sizes[i];
  },

  getFileIcon(extension: string | undefined = ''): string {
    const icon = 'cwx-icon';
    const iconMap: { [key: string]: string } = {
      '.doc': 'cwx-icon-before_file-doc',
      '.docx': 'cwx-icon-before_file-doc',
      '.exe': 'cwx-icon-before_file-exe',
      '.jpg': 'cwx-icon-before_file-jpg',
      '.pdf': 'cwx-icon-before_file-pdf',
      '.png': 'cwx-icon-before_file-png',
      '.ppt': 'cwx-icon-before_file-ppt',
      '.zip': 'cwx-icon-before_file-zip',
      '.xls': 'cwx-icon-before_file-xls',
    };

    return `${icon} ${iconMap[extension] || ' cwx-icon-before_file'}`;
  },

  getFileExtension(mimeType: string): string {
    if (mimeType.includes('msword')) {
      return '.doc';
    } else if (mimeType.includes('wordprocessingml.document')) {
      return '.docx';
    } else if (mimeType.includes('jpeg')) {
      return '.jpg';
    } else if (mimeType.includes('pdf')) {
      return '.pdf';
    } else if (mimeType.includes('png')) {
      return '.png';
    } else if (mimeType.includes('powerpoint')) {
      return '.ppt';
    } else if (mimeType.includes('text/plain')) {
      return '.txt';
    } else if (mimeType.includes('ms-excel')) {
      return '.xls';
    }

    return '';
  },

  convertUrlsToLinks(content: string): string {
    const urlMatchPattern =
      /((?:https?:\/\/)?[\w.-]+\.(?:com|net|ru|org|jp|de|br|uk|it|in|us|cn|fr|info|pl|es|au|at|fi|nl|gr|cz|ca|gov|eu|id|se|edu|io|biz|ch)[^,\s]*)/gi;
    return content.replace(urlMatchPattern, (match: string) => {
      const url = match.startsWith('http') ? match : `https://${match}`;
      return `<a href="${url}">${match}</a>`;
    });
  },

  getImageThumbnailSrc(file: IFile, size: ThumbnailSizes, multiplier: number = 1): string {
    let imageThumbnail = '';
    const dimension = this.getThumbnailDimensionsBySize(size);
    if (this.isFileThumbnailType(file)) {
      imageThumbnail = `/images/${file?.thumbnailFileId ?? file.id}/${dimension.widthInPx * multiplier}x${dimension.heightInPx * multiplier}/Idea.png`;
    }
    return imageThumbnail;
  },
  isFileThumbnailType(file: IFile): boolean {
    return (
      file.mimeType.includes('image') ||
      file.mimeType.includes('model') ||
      (file.extension && helpers.files.isVideoFile(file.extension)) ||
      this.isImageFile(file.extension)
    );
  },
  getThumbnailDimensionsBySize(size: ThumbnailSizes): FileDimension {
    switch (size) {
      case ThumbnailSizes.small:
        return ThumbnailDimensions.small;
      case ThumbnailSizes.medium:
        return ThumbnailDimensions.medium;
      case ThumbnailSizes.large:
        return ThumbnailDimensions.large;
      default:
        return ThumbnailDimensions.medium;
    }
  },
};
